module.exports = __webpack_public_path__ + "img/qr-code.d053c789.svg";